import { Link } from 'gatsby'
import React from 'react'
import Image from '../../function/Image'
import parse from 'html-react-parser'
import './PostCard.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Button from '../Button/Button'
const PostCard = (card) => {
    if (!card) return null
    return (
        <div>
            <Link
                to={card?.uri}
                className="mb-[14px] block aspect-[394/180] w-full overflow-hidden rounded-[10px] bg-dark_purple"
            >
                {card?.thumbnail?.node && (
                    <Image {...card?.thumbnail?.node} alt={card.title} className={'!object-fill'}/>
                )}
            </Link>
            <Link
                to={card?.uri}
                className="mb-[9px] transition duration-300 hover:text-sea_serpent md:pr-1"
            >
                {card?.category && (
                    <span className="pre-header mb-[13px] mt-[7px] block">
                        {card?.category.nodes[0].name}
                    </span>
                )}
                <h4>{card?.title}</h4>
            </Link>
            {card?.description && (
                <div className="post__description">
                    {parse(card?.description)}
                </div>
            )}
            {card.button && (
                <Button styles="primary" buttonLink={card.button.url}>
                    {card.button.title}
                </Button>
            )}
        </div>
    )
}

export default PostCard
